export interface PlaceConfig {
  name: string;
  business: {
    name: string;
    tenantCode: string;
  };
  address: {
    formatted: string;
  };
  logo: {
    url: string;
    urlDark: string;
    aspectRatio: number;
    backgroundColor: string;
  };
  previewImage?: {
    url: string;
    width?: number;
    height?: number;
    alt?: string;
  };
  style: {
    font: string;
    light: {
      primary: string;
      secondary: string;
      accent: string;
      background: string;
      text: string;
    };
    dark: {
      primary: string;
      secondary: string;
      accent: string;
      background: string;
      text: string;
    };
  };
}

// Default configuration
export const defaultPlaceConfig: PlaceConfig = {
  name: 'Restaurant',
  business: {
    name: 'Brand',
    tenantCode: ''
  },
  address: {
    formatted: ''
  },
  logo: {
    url: '/logo.png',
    urlDark: '/logo.png',
    aspectRatio: 1,
    backgroundColor: '#FFFFFF'
  },
  style: {
    font: 'Arial',
    light: {
      primary: '#B81A35',
      secondary: '#1A1A1A',
      accent: '#D4AF37',
      background: '#FFFFFF',
      text: '#1A1A1A'
    },
    dark: {
      primary: '#FF4066',
      secondary: '#708090',
      accent: '#D4AF37',
      background: '#333333',
      text: '#FFFFFF'
    }
  }
};
